export const getPidFromChanges = (changes: any) => {
  return changes.find((change: any) => change.field === 'pid')?.value;
};
